// src/routes/AuthenticatedRoutes.js

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/Auth/ProtectedRoute'; // <-- Keep ProtectedRoute
// Import all page components rendered within authenticated routes
import ToDoPage from '../components/ToDoPage';
import DiscoveryPage from '../components/DiscoveryPage';
import QueryPage from '../components/QueryPage';
import InfluencerPage from '../components/InfluencerPage';
import PublicationPage from '../components/PublicationPage';
import MessagesPage from '../components/MessagesPage';
import KnowledgePage from '../components/KnowledgePage';
import EmailPage from '../components/EmailPage';
import AIToolsPage from '../components/AIToolsPage';
import AIAgentPage from '../components/AiAgentPage';
// import UserProfile from "../components/Auth/UserProfile"; // REMOVED: Replaced by modal
// import VerifyEmailPage from "../components/Auth/VerifyEmailPage"; // REMOVED: Handled by /forgot-password action code flow
import SocialMediaSettings from '../components/SocialMediaSettings'; // <-- Keep this import
import NotFoundPage from '../components/NotFoundPage'; // Optional: for unmatched paths

// This component defines the <Routes> and <Route> definitions for all paths
// accessible to authenticated and verified users. AppContent.js acts as the
// primary guard by conditionally rendering this component's parent element.
// ProtectedRoute adds an *additional* layer of defense within this component.
const AuthenticatedRoutes = ({ loading }) => {
  // The `loading` prop can be passed down to individual pages if they need it.
  return (
    <Routes>
      {' '}
      {/* Nested Routes for the authenticated area */}
      {/* Define specific routes for authenticated & verified users */}
      {/* Wrap each route's element in ProtectedRoute for defense-in-depth */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <ToDoPage loading={loading} /> {/* Pass loading if needed */}
          </ProtectedRoute>
        }
      />
      <Route
        path="/discovery"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <DiscoveryPage loading={loading} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/query"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <QueryPage loading={loading} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/influencer"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <InfluencerPage loading={loading} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/publication"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <PublicationPage loading={loading} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/messages"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <MessagesPage loading={loading} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/knowledge"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <KnowledgePage loading={loading} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/email"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <EmailPage loading={loading} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai-tools"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Keep ProtectedRoute */}
            <AIToolsPage loading={loading} />
          </ProtectedRoute>
        }
      />
      {/* --- NEW: AI Agent Route --- */}
      <Route
        path="/ai-agent"
        element={
          <ProtectedRoute>
            <AIAgentPage loading={loading} />
          </ProtectedRoute>
        }
      />
      {/* --- Social Media Settings Route --- */}
      {/* This is a regular page component routed here */}
      <Route
        path="/social-media"
        element={
          <ProtectedRoute>
            {' '}
            {/* <-- Protect this route too */}
            <SocialMediaSettings />
          </ProtectedRoute>
        }
      />
      {/* REMOVED: User Profile route - Replaced by Modal */}
      {/* <Route path="/user-profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} /> */}
      {/* REMOVED: Verify Email route - Handled by /forgot-password action code flow */}
      {/* <Route path="/verify-email" element={<VerifyEmailPage />} /> */}
      {/* Optional: Catch-all within authenticated area for unmatched paths */}
      {/* If a user is logged in and verified but navigates to a path not defined above */}
      {/* Redirect them to the home page, or show a 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />{' '}
      {/* Redirect to home */}
      {/*<Route 
                  path="*" element={<NotFoundPage />} 
            />*/}
    </Routes>
  );
};

export default AuthenticatedRoutes;
